<style>

    .modal label {
        background-color: white;
        position: relative;
        right: 10px;
        top: 18px;
        padding: 0 10px;
    }

    .form-control {
        padding-top: 10px;

    }

    .form-control:disabled,
    .form-control[readonly] {
        background-color: white !important;
        opacity: 1;
    }

    .request-img {
        cursor: zoom-in!important;
    }

    .full-screen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw !important;
        max-width: 100vw !important;
        height: 100vh !important;
        max-height: 100vh !important;
        z-index: 999;
        cursor: zoom-out!important;
    }

</style>

<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>

        <div class="d-flex">

            <a class="text-white f18 my-auto"> سوابق سرویس و تعمیرات </a>

        </div>

    </div>

</div>

<div class="d-flex justify-content-start align-items-center gap-4 p-2 bg-th-blue flex-wrap dirI">

    <div class="d-flex">

        <form [formGroup]="dataAz">

            <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"

                [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" placeholder="از تاریخ" formControlName="date" class="form-control" readonly />

            </ng-persian-datepicker>

        </form>

    </div>

    <div class="d-flex">

        <form [formGroup]="datatTa">

            <ng-persian-datepicker [uiTheme]="'gray'" [dateInitValue]="false" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"

                [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" placeholder="تا تاریخ" formControlName="date" class="form-control" readonly />

            </ng-persian-datepicker>

        </form>

    </div>

    <div class="d-flex flex-wrap col-md-6 gap-3" [formGroup]="serchModel">

        <div class="col-md-5 col-11">
            <input type="text" placeholder="علت" class="form-control text-start dirI" formControlName="reson">
        </div>

        <div class="d-flex col-md-5 col-11 mt-3 mt-sm-0">
            <input type="text" placeholder="نام تعمیر کار" class="form-control text-start dirI"
                formControlName="repairer">
            <button class="btn btn-primary" (click)="serch()"><i class="fa fa-search"></i></button>
        </div>

    </div>

    <div class="d-flex col-12 d-flex justify-content-end">

        <button printTitle="سوابق سرویس و تعمیرات"
        
            printSectionId="print-section" class="btn btn-secondary pointer"

            [useExistingCss]="true" ngxPrint> چاپ 

            <i class="fa fa-print"></i>

        </button>

        <button class="btn btn-success mx-2 pointer"

            (click)="otherService.exportexcel('excel-table-repairsRep', 'سوابق سرویس و تعمیرات.xlsx')">
            
            <i class="fa fa-file-excel-o"></i>
                
                &nbsp; خروجی اکسل
            
        </button>

    </div>

</div>

<div id="print-section">
    <div class="row dirI">
        <div class="col-10 text-center align-items-center border">
            <p class="mt-2 fw-bold">
                {{loggedinUserName}}
            </p>
            <p>گزارش تعمیرات {{vehicle.ownerName}} با شماره پلاک <span class="license-plate"
                    style="height: auto; margin-top: .1rem;">{{vehicle.plate.split("").reverse().join("")}}</span> در
                {{vehicle.hoze}} از تاریخ
                {{dataAz.controls['date'].value | faNum}} تا تاریخ {{datatTa.controls['date'].value |faNum}}</p>
        </div>
        <div class="col-2 text-center align-items-center border">
            <p class="p-2">تاریخ تهیه</p>
            {{currentDate | faNum}}
        </div>
    </div>
    <div class="table-responsive table-striped dirI">
        <div class="w-100 bg-th-blue position-sticky" style="bottom: 0;" *ngIf="Repairs?.length > 0">
            <div class="d-flex justify-content-around align-items-center flex-wrap dirI">
                <span class="text-white">تعداد کل : {{Repairs?.length | faNum}} مورد</span>
                <span class="text-white">مجموع هزینه : {{getSeparatedValue(this.summeryReview.totalCost) | faNum}}
                    ریال</span>
            </div>
        </div>
        <table class="table table-bordered" id='excel-table-repairsRep'>

            <thead>

                <tr class="text-center f12">

                    <th scope="col" class="">ردیف</th>

                    <th scope="col" class="">تاریخ</th>

                    <th scope="col" class="">کیلومتر</th>

                    <th scope="col" class="">موضوع</th>

                    <th scope="col" class="">تعمیرکار</th>

                    <th scope="col" class="">هزینه (ریال)</th>

                </tr>
                
            </thead>
            
            <tbody>

                <tr class="text-center f12" *ngFor="let item of Repairs;let i=index">

                    <th class="text-secondary">{{i+1 | faNum}}</th>

                    <th class="text-secondary">{{item.strDate | faNum }}</th>

                    <th class="text-secondary">{{getSeparatedValue(item.iKM)}}</th>

                    <th class="text-secondary">{{item.strReason | faNum}}</th>

                    <th class="text-secondary">{{item.strRepairman | faNum}}</th>

                    <th class="text-secondary">{{getSeparatedValue(item.iTotalCost)}}</th>

                </tr>

            </tbody>

        </table>

    </div>

</div>

<div class="w-100 bg-th-blue position-sticky" style="bottom: 0; " *ngIf="Repairs?.length > 0">

    <div class="d-flex justify-content-around align-items-center flex-wrap dirI mt-1">

        <span class="text-white"> تعداد کل : {{Repairs?.length | faNum}} مورد</span>

        <span class="text-white"> مجموع هزینه : {{getSeparatedValue(this.summeryReview.totalCost) | faNum}}

            ریال    

        </span>

    </div>

</div>

<div class="table-responsive dirI rounded-3  my-2" style="max-height: 80vh; overflow-y: auto;">

    <table class="table table-striped dirI">

        <thead class="">

            <tr class="text-center">

                <th scope="col" class="border border-2 bg-secondary">#</th>

                <th scope="col" class="border border-2 bg-secondary">تاریخ</th>

                <th scope="col" class="border border-2 bg-secondary">کاربر ثبت کنده </th>

                <th scope="col" class="border border-2 bg-secondary">تعمیر کار</th>

                <th scope="col" class="border border-2 bg-secondary">علت</th>

                <th scope="col" class="border border-2 bg-secondary">مبلغ (ریال)</th>

            </tr>

        </thead>

        <tbody>

            <tr class="text-center f14" *ngFor="let item of Repairs; let i =index" 

                [ngClass]="acssess.bRepairs_User_Edit ? 'hoverMenu pointer' : '' "
            
                (click)="acssess.bRepairs_User_Edit ? getSingel(i) : '' ">

                <th class="text-dark border border-2 col-1">{{ i + 1 | faNum}}</th>

                <th class="text-dark border border-2 col-2">{{item.strDate | faNum }}</th>

                <th class="text-dark border border-2 col-2">{{item.strUserSaved | faNum }}</th>

                <th class="text-dark border border-2 col-2">{{item.strRepairman | faNum }}</th>

                <th class="text-dark border border-2 col-3">{{item.strReason }}</th>

                <th class="text-primary border border-2 col-2">{{ getSeparatedValue(item.iTotalCost) }}</th>

            </tr>

        </tbody>

    </table>

</div>

<!-- Button trigger modal -->

<button *ngIf="acssess.bRepairs_User_Save" type="button" class="btn btn-primary btn-plus" 

    data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="open()">

    <i class="fa fa-plus fa-2x"></i>

</button>

<!-- Modal -->

<div class="modal fade rtl " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title text-th-blue d-flex align-items-center" id="exampleModalLabel">

                    <span> {{ EditeMod ? 'ویرایش تعمیرات' : 'ثبت تعمیرات' }} </span>

                </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body " style="max-height: 700px;overflow: auto;">

                <form [formGroup]="sabtModel" class="d-flex flex-wrap justify-content-around">

                    <div class="col-md-5 col-11 mx-auto">

                        <label class="mb-2"> * تاریخ </label>

                        <form [formGroup]="datasabt">

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"

                                [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" formControlName="date" class="form-control  text-end" readonly />
                                    
                            </ng-persian-datepicker>

                        </form>

                    </div>

                    <div class="col-md-5 col-11 mx-auto mt-0">

                        <label class="mb-2"> * هزینه کل ( ریال ) </label>

                        <input type="text" class="form-control text-end lirI" formControlName="iTotalCost" (keypress)="seprator($event)" />

                    </div>

                    <div class="col-md-5 col-11 mx-auto mt-0">

                        <label class="mb-2">موضوع</label>

                        <input type="text" class="form-control " formControlName="strReason" />

                    </div>

                    <div class="col-md-5 col-11 mx-auto mt-0">

                        <label class="mb-2"> کیلومتر فعلی </label>

                        <input type="text" class="form-control text-end lirI" formControlName="iKM" (keypress)="seprator($event)" />

                    </div>

                    <div class="col-11 mx-auto mt-0">

                        <label class="mb-2"> نام تعمیر کار </label>

                        <input type="text" class="form-control " formControlName="strRepairman"/>

                    </div>

                    <div class="col-11 mx-auto mt-0">

                        <label class="mb-2"> توضیحات </label>

                        <textarea style="height: 110px;resize: none;" type="text" class="form-control" formControlName="strComment">
                        
                        </textarea>

                    </div>

                    <div *ngIf="lstMdlRepairMaintenance.length" class="col-12 row gx-2 px-2 px-md-5 mt-3">

                        <ng-container *ngFor="let item of lstMdlRepairMaintenance">

                            <ng-container *ngIf="item.tiStatus != 0 || item.bExpanded">

                                <div class="col-12 col-md-3 border border-1 p-2">
                                        
                                    <p> عنوان : <strong> {{ item.strTitle }} </strong> </p>

                                    <p> اقدامات : 
                                        
                                        <strong> 
                                            
                                            {{ 
                                            
                                            item.tiStatus == 0  ? 'بدون اقدام' :
                                            
                                            item.tiStatus == 1  ? 'بازدید شده' :
                                            
                                            item.tiStatus == 2  ? 'تعمیر شده' :
        
                                            item.tiStatus == 3  ? 'تعویض' : ''
                                            
                                            }}
                                        
                                        </strong>
                                    
                                    </p>
        
                                    <p> هزینه : 
                                        
                                        <strong> {{ item.iCost != 0 ? (item.iCost.toLocaleString() + ' ریال' | faNum) : '- - -' }} </strong>
                                    
                                    </p>
        
                                    <p> توضیحات : 
                                        
                                        <strong> {{ item.strComment != '' ? item.strComment : '- - -' }} </strong>

                                    
                                    </p>

                                </div>

                            </ng-container>

                        </ng-container>                        

                    </div>

                    <div class="w-100 row gx-2 gy-2 justify-content-center p-3">

                        <div class="col-12 col-md-4 p-2">

                            <button class="btn btn-primary w-100" (click)="openServiceType_Modal()"> انتخاب سرویس ها </button>

                        </div>

                        <div class="col-12 col-md-4 p-2">

                            <button class="btn btn-primary w-100" (click)="fileInput.click()"> تصویر فاکتور </button>

                            <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0])"/>

                        </div>

                        <div *ngIf="sabtModel.value.strImage != '' "  class="col-md-5 col-11 mx-auto mt-2">

                            <img class="request-img border border-2 rounded p-2 pointer"
                            
                                width="100%" style="max-height: 360px;object-fit: cover;"
                                
                                src="data:image/jpeg;base64,{{sabtModel.value.strImage}}"
                                    
                                id="fullScreen_" (click)="fullScreen_Image()" >
    
                        </div>

                    </div>

                </form>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success px-5" 
                
                    (click)="sabt()" *ngIf="!EditeMod && acssess.bRepairs_User_Save">
                    
                    ذخیره 
                
                </button>

                <button type="button" class="btn btn-primary px-5" 
                
                    (click)="edit()" *ngIf="EditeMod && acssess.bRepairs_User_Edit">
                    
                    ویرایش 
            
                </button>

                <button type="button" class="btn btn-danger px-5" 
                
                    (click)="deleteRepair()" *ngIf="EditeMod && acssess.bRepairs_User_Delete">
                    
                    حذف 
                
                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="serviceType_Modal" tabindex="-1" aria-labelledby="serviceType_Modal" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title d-flex align-items-center" id="serviceType_Modal">

                    <span> سرویس ها </span>

                </h5>

                <button type="button" class="btn-close" (click)="backToSave()"></button>

            </div>

            <div class="modal-body rox gx-2 " style="max-height:600px; overflow: auto;">

                <div *ngFor="let item of lstMdlRepairMaintenance; let i = index" 
                
                    class="col-12 border border-2 p-2 mb-2 pointer">

                    <div class="row gx-2">

                        <p class="col-6 fw-bold"> {{ item.strTitle | faNum }} </p>

                        <p class="col-6 fw-bold text-end pe-2 pointer"> 

                            <i *ngIf="!item.bExpanded" class="fa fa-chevron-down" aria-hidden="true" (click)="item.bExpanded = true"></i>

                            <i *ngIf="item.bExpanded" class="fa fa-chevron-up" aria-hidden="true" (click)="item.bExpanded = false"></i>

                        </p>

                        <span class="col-6 col-md-3 d-flex justify-content-start align-items-center">

                            <input type="radio" checked [(ngModel)]="item.tiStatus"
                            
                                [value]="0" [name]="item.iRepairMaintenanceType" (click)="setStatus_ServiceType(i,0)">
    
                            <span class="ms-2"> بدون اقدام </span>
    
                        </span>
    
                        <span class="col-6 col-md-3 d-flex justify-content-start align-items-center">
    
                            <input type="radio" [value]="1" [(ngModel)]="item.tiStatus"
                            
                                [name]="item.iRepairMaintenanceType" (click)="setStatus_ServiceType(i,1)">
    
                            <span class="ms-2"> بازدید </span>
    
                        </span>
    
                        <span class="col-6 col-md-3 d-flex justify-content-start align-items-center">
    
                            <input type="radio" [value]="2" [(ngModel)]="item.tiStatus"
                            
                                [name]="item.iRepairMaintenanceType" (click)="setStatus_ServiceType(i,2)">
    
                            <span class="ms-2"> تعمیر </span>
    
                        </span>
    
                        <span class="col-6 col-md-3 d-flex justify-content-start align-items-center">
    
                            <input type="radio" [value]="3" [(ngModel)]="item.tiStatus"
                            
                                [name]="item.iRepairMaintenanceType" (click)="setStatus_ServiceType(i,3)">
    
                            <span class="ms-2"> تعویض </span>
    
                        </span>

                    </div>

                    <div *ngIf="item.bExpanded" class="p-2 mt-3">

                        <input type="text" 

                            class="form-control w-100 mb-2" name="iCost"
                            
                            [(ngModel)]="item.iCost" placeholder="هزینه (ریال) : "
                            
                            (keypress)="seprator($event)">

                        <textarea class="form-control" name="strComment" 
                        
                            [(ngModel)]="item.strComment"  placeholder="توضیحات :"
                        
                            style="height: 80px; max-height: 80px; resize: none;">
                        
                        </textarea>

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                 <button type="button" class="btn btn-success px-5" (click)="backToSave()"> 
                    
                    تایید
                
                </button>

            </div>

        </div>

    </div>

</div>